const MONETARY_AMOUNT_REGEX = /^\d+(\.\d{0,2})?$/;
/**
 * Validates that a value is a monetary amount.
 */
export const Validator = {
    name: "monetary_amount",
    errorMessage: "Field should be a non-negative decimal number with max. 2 fractional digits.",
    validate: value => MONETARY_AMOUNT_REGEX.test(`${value}`),
};
